import { render, staticRenderFns } from "./carrier-master-comp.vue?vue&type=template&id=491a5728&"
import script from "./js/carrier-master-comp.js?vue&type=script&lang=js&"
export * from "./js/carrier-master-comp.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports